import React from 'react';
import { motion } from 'framer-motion';
import { Database, Brain, Cpu, LineChart, Shield, Zap } from 'lucide-react';

const Services: React.FC = () => {
  const services = [
    {
      icon: <Database className="w-8 h-8" />,
      title: 'Data Engineering',
      description: 'Modern data stack implementation with scalable pipelines',
      color: 'from-ariyva-indigo to-ariyva-electric'
    },
    {
      icon: <Brain className="w-8 h-8" />,
      title: 'AI Strategy',
      description: 'Practical AI/ML implementation roadmaps',
      color: 'from-ariyva-neural to-ariyva-amber'
    },
    {
      icon: <Cpu className="w-8 h-8" />,
      title: 'Automation',
      description: 'Intelligent process automation and workflows',
      color: 'from-ariyva-circuit to-ariyva-cyan'
    },
    {
      icon: <LineChart className="w-8 h-8" />,
      title: 'Analytics',
      description: 'Real-time dashboards and business intelligence',
      color: 'from-ariyva-electric to-ariyva-cyan'
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'Governance',
      description: 'Data security, compliance, and quality frameworks',
      color: 'from-ariyva-amber to-ariyva-terracotta'
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: 'Optimization',
      description: 'Performance tuning and cost optimization',
      color: 'from-ariyva-cyan to-ariyva-indigo'
    },
  ];

  return (
    <section id="solutions" className="section-padding bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="gradient-text">Solutions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            End-to-end data capabilities from strategy to implementation
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card rounded-2xl p-6 hover:shadow-xl transition-all duration-300 card-hover group"
            >
              <div className={`w-16 h-16 rounded-xl bg-gradient-to-r ${service.color} p-3 mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <div className="text-white">
                  {service.icon}
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-4">
                {service.description}
              </p>
              
              <a 
                href="#contact" 
                className="inline-flex items-center text-ariyva-electric font-medium hover:text-ariyva-indigo transition-colors"
              >
                Learn more →
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;